<template>
  <div>
    <h2>
      <span class="step-name">
        Animal Numbers - Beef
      </span>
      <comments field-name='heading_animal_numbers_beef'></comments>
    </h2>

    <h3>Animal numbers are numbers wintered or expected to be wintered for the consult year</h3>

    <div class="step-section" v-for="gf_animal in enabledAnimals('beef', false)" :key="'beef_'+gf_animal.id">
      <div class="row">
      <h3> {{ gf_animal.name }} </h3>

        <div class="row">
          <div class="col-md-6 col-md-offset-3">
            <text-area label="Animal Notes from Ezyvet" :field-name="`animal_${gf_animal.id}-notes`" disabled>
            </text-area>
          </div>
        </div>

      <div class="col-md-6">
        <h3>Previous Consult</h3>

        <div class="form-group input-box">
          <label>Breeding Cows</label>
          <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-breeding_cows`]" disabled>
        </div>

        <div class="form-group input-box">
          <label>Heifers</label>
          <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-heifers`]" disabled>
        </div>

        <div class="form-group input-box">
          <label>Fattening</label>
          <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-fattening`]" disabled>
        </div>

        <div class="form-group input-box">
          <label>Bulls</label>
          <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-bulls`]" disabled>
        </div>

          <div class="form-group input-box">
            <label>Maternal Breed</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-maternal_breed`]" disabled>
          </div>

          <div class="form-group input-box">
            <label>Terminal Breed</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-terminal_breed`]" disabled>
          </div>

        <div class="form-group input-box">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" :checked="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-stud_breeder`]" disabled>
            <label class="form-check-label" for="stud_breeder">
              Stud Breeder
            </label>
          </div>
        </div>

        <div class="form-group input-box">
          <label for="functional_head_bail">Functional Head Bail</label>
          <div class="radio">
            <label class="radio-inline">
              <input type="radio" :checked="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-functional_head_bail`] == true" disabled>Yes
            </label>
            <label class="radio-inline">
              <input type="radio" :checked="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-functional_head_bail`] == false" disabled>No
            </label>
          </div>
        </div>

        <div class="form-group input-box">
          <label for="safe_yards_available">Safe Yards Available</label>
          <div class="radio">
            <label class="radio-inline">
              <input type="radio" :checked="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-safe_yards_available`] == true" disabled>Yes
            </label>
            <label class="radio-inline">
              <input type="radio" :checked="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-safe_yards_available`] == false" disabled>No
            </label>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <h3>This Year</h3>
        <number-input label="Breeding Cows"
                      :field-name="`animal_${gf_animal.id}-breeding_cows`">
        </number-input>

        <number-input label="Heifers"
                      :field-name="`animal_${gf_animal.id}-heifers`">
        </number-input>

        <number-input label="Fattening"
                      :field-name="`animal_${gf_animal.id}-fattening`">
        </number-input>

        <number-input label="Bulls"
                      :field-name="`animal_${gf_animal.id}-bulls`">
        </number-input>


          <text-input label="Maternal Breed"
            :farm-id="gf_animal.id"
            field-name="maternal_breed"
            field-prefix="animal">
          </text-input>

          <text-input label="Terminal Breed"
            :farm-id="gf_animal.id"
            field-name="terminal_breed"
            field-prefix="animal">
          </text-input>

        <check-box label="Stud Breeder"
                   :field-name="`animal_${gf_animal.id}-stud_breeder`">
        </check-box>


        <radio-input label="Functional Head Bail"
                     :field-name="`animal_${gf_animal.id}-functional_head_bail`"
                     :choices="[
                       {value: true, display: 'Yes'},
                       {value: false, display: 'No'},
                     ]">
        </radio-input>

        <radio-input label="Safe Yards Available"
                    :field-name="`animal_${gf_animal.id}-safe_yards_available`"
                    :choices="[
                      {value: true, display: 'Yes'},
                      {value: false, display: 'No'},
                    ]">
        </radio-input>
      </div>
    </div>
    </div>

    <div class="step-section" v-for="gf_animal in newAnimals('beef')" :key="'new_beef_'+gf_animal.frontend_id">
      <div class="row">
      <h3> {{ gf_animal.name }} - (Newly created) </h3>

      <div class="col-md-6">
        <h3>This Year</h3>
        <number-input label="Breeding Cows"
                      :field-name="`new_animal_${gf_animal.frontend_id}-breeding_cows`">
        </number-input>

        <number-input label="Heifers"
                      :field-name="`new_animal_${gf_animal.frontend_id}-heifers`">
        </number-input>

        <number-input label="Fattening"
                      :field-name="`new_animal_${gf_animal.frontend_id}-fattening`">
        </number-input>

        <number-input label="Bulls"
                      :field-name="`new_animal_${gf_animal.frontend_id}-bulls`">
        </number-input>

          <text-input label="Maternal Breed"
            :farm-id="gf_animal.frontend_id"
            field-name="maternal_breed"
            field-prefix="new_animal">
          </text-input>

          <text-input label="Terminal Breed"
            :farm-id="gf_animal.frontend_id"
            field-name="terminal_breed"
            field-prefix="new_animal">
          </text-input>

        <check-box label="Stud Breeder"
                   :field-name="`new_animal_${gf_animal.frontend_id}-stud_breeder`">
        </check-box>


        <radio-input label="Functional Head Bail"
                     :field-name="`new_animal_${gf_animal.frontend_id}-functional_head_bail`"
                     :choices="[
                       {value: true, display: 'Yes'},
                       {value: false, display: 'No'},
                     ]">
        </radio-input>

        <radio-input label="Safe Yards available"
                    :field-name="`new_animal_${gf_animal.frontend_id}-safe_yards_available`"
                    :choices="[
                      {value: true, display: 'Yes'},
                      {value: false, display: 'No'},
                    ]">
        </radio-input>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

import { mapGetters } from 'vuex'

export default {
  name: 'AnimalNumbersBeef',
  mixins: [ baseComponent ],
  computed: {
    ...mapGetters('currentConsult', ['enabledAnimals', 'newAnimals']),
  },
};
</script>
